<ion-header class="ion-header-set-password">
  <ion-toolbar>
    <div class="header-grid">
      <div class="main-logo-sec">
        <img src="assets/images/eZintegration-black-logo.svg">
      </div>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="container">
    <div class="bg-grid">
      <div class="grid-container">
        <div class="grid-content">
          <div class="company-logo-sec">
            <img src="assets/images/bizdata-header-logo.png">
          </div>

          <mat-card class="p-0">
            <mat-card-content>
              <div class="signup-sec">
                 Forgot Password
              </div>
               <div class="content-grid">                           
                    <div class="img">
                      <div class="imgtext">
                        <h2> Reset Your Password</h2>
                      </div>
                    </div>              
                  <div class="col-spacing">
                    <div class="main-logo-sec">
                      <img src="assets/images/eZintegration-black-logo.svg">
                    </div>
                    <!-- <span class="bg-sub-content"> Reset your password </span> -->
                    <div class="text">{{msg}}</div>
                    <div class="form-container">
                      <ng-container *ngIf="!showSuccessMessage">
                        <form [formGroup]="forgotform" (ngSubmit)="onSubmitforgot()">
                          <mat-form-field appearance="outline">
                            <mat-label> Email ID</mat-label>
                            <input type="text" formControlName="email" matInput placeholder=" Email" required>
                            <mat-error *ngIf="submitted && f.email.hasError('email')">Email must be valid. </mat-error>
                          </mat-form-field>
  
                          <div class="btn-grid">
                            <button mat-raised-button type="submit" class="btn-set-password">Send</button>
                          </div>
                        </form>
                      </ng-container>
                      <div class="back-login">
                        <p>Return to <a class="signin-link" style="text-decoration: none; font-weight: 500;  " routerLink="/vendor/login" href="javascript:void(0)"> Signin </a></p>
                      </div>
                    </div>
                  </div>
            </div>    
            </mat-card-content>

          </mat-card>
          <app-powered-by-footer></app-powered-by-footer>
        </div>
      </div>
    </div>
  </div>
</ion-content>
